import { getGaGeoLabel } from './getGaGeoLabel';
import { getRegionId } from './getRegionId';
import { TApplicationState } from 'shared/types/redux';
import { MOSCOW_AND_MO_IDS } from '../../constants/region';

export function getAnalyticsRegionId(state: TApplicationState): number | string | null {
  const regionId = getRegionId(state);
  if (!regionId) {
    return null;
  }

  if (MOSCOW_AND_MO_IDS.includes(regionId)) {
    return getGaGeoLabel(state);
  }

  return regionId;
}
